import styled from 'styled-components';
import { Layout, Button, Typography, Input } from 'antd';
import { Link } from 'react-router-dom';

const { Header, Footer, Content } = Layout;
const { Title } = Typography;

export const StyledLayout = styled(Layout)`
  background-color: #000000;
  min-height: 100vh;
`;

export const StyledHeader = styled(Header)`
  background-color: #000000;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledContent = styled(Content)`
  padding: 0;
`;

export const StyledFooter = styled(Footer)`
  background-color: #000000;
  padding: 20px 50px;

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const StyledTitle = styled(Title)`
  color: #ffe955 !important;
  font-size: 58px !important;
  color: white !important;
  font-weight: 700 !important;
  margin-bottom: 20px !important;

  @media (max-width: 768px) {
    font-size: 36px !important;
  }
`;

export const StyledSectionTitle = styled(Title)`
  color: #ffe955 !important;
  font-size: 42px !important;
  color: white !important;
  font-weight: 700 !important;
  margin-bottom: 20px !important;

  @media (max-width: 768px) {
    font-size: 28px !important;
  }
`;

export const StyledSubtitle = styled.p`
  color: #FFFFFF;
  font-size: 1.25rem;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const StyledRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const StyledCol = styled.div`
  flex: 1;
  padding: 0 15px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    flex-basis: 100%;
    max-width: 100%;
    padding: 0;
  }
`;

export const StyledLink = styled.a`
  color: #ffe955;
  &:hover {
    color: #FFC000;
  }
`;

export const StyledIcon = styled.span`
  color: #ffe955;
  font-size: 24px;
  margin-right: 10px;
`;

export const StyledNavLink = styled(Link)`
  font-weight: bold;
  height: 48px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  text-decoration: none;
  border-radius: 4px;

  &.login {
    color: #ffe955;
    background-color: transparent;
    margin-right: 20px;
  }

  &.signup {
    background-color: #ffe955;
    color: #000000;

    &:hover, &:focus {
      background-color: #FFC000;
      color: #000000;
    }
  }

  @media (max-width: 768px) {
    margin-bottom: 10px;
    width: 100%;
    justify-content: center;
  }
`;

export const SectionContent = styled.div`
  max-width: 1200px;
  margin: auto;
  text-align: center;

  @media (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const StyledGradientSection = styled.div`
  background: linear-gradient(to bottom, #000, #2e2e2e);
  padding: 80px 20px;
  text-align: center;

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

export const StyledInput = styled(Input)`
  && {
    height: 60px;
    font-size: 18px;
    background-color: transparent;
    color: white;
    border: 3px solid #ffe955;
    transition: box-shadow 0.3s ease;

    &::placeholder {
      color: grey;
      opacity: 1;
    }

    &::-webkit-input-placeholder { color: grey; }
    &::-moz-placeholder { color: grey; }
    &:-ms-input-placeholder { color: grey; }
    &:-moz-placeholder { color: grey; }

    &:hover {
      box-shadow: 0 0 20px #ffe955;
    }

    &:focus {
      box-shadow: 0 0 15px #ffe955;
      outline: none;
    }

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }
`;

export const StyledChatBubble = styled.div`
  color: #000;
  padding: 15px 30px;
  border-radius: 25px;
  display: inline-block;
  max-width: 100%;
  font-weight: 700;
  background-color: #ffe955;
  text-align: left;
  word-wrap: break-word;

  @media (max-width: 768px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`;

export const StyledChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const StyledInputContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: none;
  margin: 20px auto;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const StyledTagButton = styled(Button)`
  margin: 4px;
  color: #ffe955;
  padding: 17px;
  border-radius: 25px !important;
  border-color: #ffe955;
  border: 2px solid;
  background: transparent;
  
  &:hover, &:focus {
    color: #000000 !important;
    border-color: #ffe955 !important;
    background: #ffe955 !important;
  }

  && {
    color: #ffe955;
    border-color: #ffe955;
    background: transparent;
  
    &:hover, &:focus {
      color: #000000 !important;
      border-color: #ffe955 !important;
      background: #ffe955 !important;
    }
  }

  @media (max-width: 768px) {
    padding: 10px;
    font-size: 14px;
  }
`;

export const StyledNameGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 20px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const StyledNameButton = styled(Button)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background-color: transparent !important;
    border: 2px solid #ffe955 !important;
    border-radius: 25px !important;
    color: #ffe955 !important;
    transition: all 0.3s ease !important;
    
    &:hover, &:focus {
      background-color: #ffe955 !important;
      color: #000000 !important;
      border-color: #ffe955 !important;
    }

    &:hover .get-name, &:focus .get-name {
      color: #000000 !important;
    }

    .name {
      font-size: 1em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 10px;
    }

    .get-name {
      font-size: 0.8em;
      white-space: nowrap;
      transition: color 0.3s ease;
    }

    @media (max-width: 1200px) {
      .name {
        font-size: 0.9em;
      }
      .get-name {
        font-size: 0.7em;
      }
    }

    @media (max-width: 768px) {
      .name {
        font-size: 1em;
      }
      .get-name {
        font-size: 0.8em;
      }
    }
  }
`;

export const StyledStepSection = styled.div`
  background: #000;
  padding: 50px 20px;
  color: #FFFFFF;

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

export const StyledStepIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 20%;
  background-color: #ffe955;
  color: #000000;
  font-size: 24px;
  margin-bottom: 20px;
  position: relative;

  span {
    position: absolute;
    bottom: -10px;
    right: -10px;
    background-color: #000000;
    color: #ffe955;
    border: 2px solid #ffe955;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
  }

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
    font-size: 20px;

    span {
      width: 25px;
      height: 25px;
      font-size: 12px;
    }
  }
`;

export const StyledStepContent = styled.div`
  text-align: left;
  h3 {
    color: #FFFFFF;
    margin-bottom: 10px;
  }

  p {
    color: #FFFFFF;
  }

  @media (max-width: 768px) {
    text-align: left;

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 14px;
    }
  }
`;